import * as Yup from "yup";
import validationUtils from "./ValidationUtils.js";

const forgetPasswordSchema = Yup.object().shape({
  email: validationUtils?.validateEmail(),
});

export default forgetPasswordSchema;
